// extracted by mini-css-extract-plugin
module.exports = {"container":"WebinarPage_container__f_d_B","goBack":"WebinarPage_goBack__c7eV0"};